import React from 'react';
import { Box, Text } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Divider from '@/components/Divider';

const TransitDetail = ({ stopOver, location }) => (
  <Box maxWidth="340px" my="4">
    <Divider my="2" />
    <Text color="greys.steel" fontSize="sm">
      {`Stopover in ${location} ${stopOver.hours}h ${stopOver.mins}min`}
    </Text>
    <Divider my="2" />
  </Box>
);

TransitDetail.propTypes = {
  stopOver: PropTypes.shape({
    days: PropTypes.number,
    hours: PropTypes.number,
    mins: PropTypes.number,
  }).isRequired,
  location: PropTypes.string.isRequired,
};

export default TransitDetail;
